import { Button } from "@mantine/core";
import type { ISummaryItem } from "../../../../../pages/Summary/Summary.types";

interface Props {
  items: ISummaryItem[];
  setItems: (items: any) => void;
}

const SelectAllButton = ({ setItems, items }: Props) => {
  return (
    <Button variant="outline" onClick={() => setItems(items)}>
      Select All
    </Button>
  );
};
export default SelectAllButton;
